import React, { useState } from "react";
import BeforeAfter from "./BeforeAfter";
import { useContent } from "../../context/ContentContext";
import { useReveal } from "../../hooks/useReveal";

export default function Transformations() {
  const ref = useReveal();
  const { content } = useContent();
  const projects = (content.projects || []).filter((p) => p.before && p.image);
  const [active, setActive] = useState(0);

  if (projects.length === 0) return null;
  const current = projects[Math.min(active, projects.length - 1)];

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div ref={ref} className="max-w-6xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="homi-section-tag text-homi-goldDark text-sm">See The Transformation</span>
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl text-homi-black mt-3">
            Drag to Reveal the Difference
          </h2>
          <p className="text-homi-body mt-3">Slide left and right to compare before and after on our recent builds.</p>
        </div>

        <div className="reveal">
          <BeforeAfter before={current.before} after={current.image} />
        </div>

        <div className="flex flex-wrap justify-center gap-3 mt-8">
          {projects.map((p, i) => (
            <button
              key={p.id}
              onClick={() => setActive(i)}
              className={`relative rounded-xl overflow-hidden w-24 h-16 border-2 transition-all ${i === active ? "border-homi-gold scale-105" : "border-transparent opacity-70 hover:opacity-100"}`}
            >
              <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
        <p className="text-center font-heading font-bold text-homi-black mt-4">{current.title}</p>
      </div>
    </section>
  );
}
